import React, { useState, useEffect } from "react";
import { useEvent } from "@hooks/useEvent";
import { Input, Text } from "@fragments";
import { SafetyCheckRounded, AccessTimeRounded } from "@mui/icons-material";
import EVENTS from "../events";

export default function WaitDaysAfterPayment({ value, onChange, initialHasPlans }) {
    const [hasPlans, setHasPlans] = useState(initialHasPlans);
    const [mode, setMode] = useState(value ? 'wait' : 'immediate');
    const [days, setDays] = useState(value || '');

    useEvent(EVENTS.AVAILABILITY_CHANGE, (plans) => {
        setHasPlans(plans && plans.length > 0);
    });

    useEffect(() => {
        if (!hasPlans) {
            // Reset if no plans selected (optional, but good UX to maybe hide or reset)
        }
    }, [hasPlans]);

    function handleModeChange(newMode) {
        console.log(newMode);
        if (!newMode) return;
        setMode(newMode);
        if (newMode === 'immediate') {
            setDays(null);
            onChange(null);
        } else {
            if (days) onChange(days);
            else onChange(null);
        }
    }

    function handleDaysChange(val) {
        if (val && parseInt(val) > 365) {
            val = "365";
        }
        setDays(val);
        onChange(val);
    }

    if (!hasPlans) return null;

    const suggestions = [
        { value: 3, label: "3 dias", icon: <AccessTimeRounded /> },
        { value: 7, label: "7 dias", icon: <AccessTimeRounded /> },
        { value: 14, label: "14 dias", icon: <AccessTimeRounded /> },
        { value: 30, label: "30 dias", icon: <AccessTimeRounded /> },
    ];

    return (
        <div className="mt-5">
            <Text.h3
                value="Liberação após o pagamento"
                left={<SafetyCheckRounded />}
                className="mb-1"
            />

            <Input.Choices
                className="mt-2 mb-2"
                value={mode}
                onInput={handleModeChange}
                options={[
                    { label: "Liberar imediatamente", value: "immediate" },
                    { label: "Aguardar alguns dias para liberar acesso", value: "wait" }
                ]}
            />

            {mode === 'wait' && (
                <div className="pl-2 border-left-surface-7" style={{ borderLeft: "2px solid var(--surface-7)", marginLeft: "8px" }}>
                    <Input.Integer
                        value={days}
                        onInput={handleDaysChange}
                        label="Dias após o pagamento"
                        placeholder="Ex: 7"
                        maxLength={3}
                        max={3}
                        suggestions={suggestions}
                    />
                </div>
            )}
        </div>
    );
}
